import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  planSelectionTitle: {
    defaultMessage: 'Select Plan',
    description: 'Title for the collapsible area where user selects there plan they would like.',
    id: '/EUJr1',
  },
});
